/**
 *
 * UserInfoDialog
 *
 */

import UserInfoDialog from './UserInfoDialog.jsx';
import './UserInfoDialog.less';

export default UserInfoDialog;
